import { forwardRef, HTMLAttributes } from 'react'

import cn from '@/utils/tailwind/cn'

export const DropdownRoot = forwardRef<
  HTMLDivElement,
  HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    className={cn(
      'absolute z-9999 hidden min-w-[388px] rounded border border-gray-100 bg-white pb-8 shadow-[0_1px_3px_1px_rgba(60,64,67,.15)]',
      className
    )}
    ref={ref}
    {...props}
  />
))
